import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Notificaciones from './Notificaciones';
import MenuLateral from './MenuLateral';
import { useTranslation } from 'react-i18next';
import '../css/sidebar.css';

/**
 * Sidebar lateral fija: reemplaza el Header superior en las rutas de la app
 * (dashboard, tickets, etc). El panel en sí vive en MenuLateral, compartido
 * con el Header público para que el menú responsive sea idéntico.
 */
// Por encima de 1100px la sidebar es el rail fijo y lleva su propia campana;
// por debajo se convierte en cajón y la campana la pone .mobile-topbar.
const CONSULTA_ESCRITORIO = '(min-width: 1101px)';

const Sidebar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [esEscritorio, setEsEscritorio] = useState(() => window.matchMedia(CONSULTA_ESCRITORIO).matches);

  useEffect(() => {
    const mq = window.matchMedia(CONSULTA_ESCRITORIO);
    const onChange = (e) => setEsEscritorio(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  // Mismo comportamiento que el Header público: blur/sombra al hacer scroll.
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = isMobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isMobileOpen]);

  return (
    <>
      {/* Barra superior móvil: logo + notificaciones + burger, siempre
          en el flujo del documento (nada flotante) y sticky arriba.
          Sustituye al botón suelto que dejaba el resto del header oculto
          dentro de la sidebar transformada fuera de pantalla. */}
      <div className={`mobile-topbar ${isScrolled ? 'scrolled' : ''}`}>
        <Link to="/" className="logo-link" onClick={() => window.scrollTo({ top: 0 })}>
          <img className="header-logo" src="/images/logoadhoc.svg" alt={t('comun.marcaLogo')} />
        </Link>
        <div className="mobile-topbar-actions">
          <Notificaciones />
          <button
            type="button"
            className={`menu-icon ${isMobileOpen ? 'open' : ''}`}
            onClick={() => setIsMobileOpen((prev) => !prev)}
            aria-label={isMobileOpen ? t('comun.cerrarMenu') : t('comun.abrirMenu')}
            aria-expanded={isMobileOpen}
          >
            <span className="burger-line"></span>
            <span className="burger-line"></span>
          </button>
        </div>
      </div>

      <div className={`sidebar-overlay ${isMobileOpen ? 'open' : ''}`} onClick={() => setIsMobileOpen(false)} />

      <MenuLateral
        open={isMobileOpen}
        onClose={() => setIsMobileOpen(false)}
        conNotificaciones={esEscritorio}
      />
    </>
  );
};

export default Sidebar;
